
import TileLayer from "ol/layer/Tile";
import TileArcGISRest from "ol/source/TileArcGISRest";

// Service URLs come from .env at request time, see config/map.php and layouts/master.blade.php.
const { orthoUrl, topoUrl } = window.mapConfig;

// Both layers use ArcGIS ImageServer or MapServer services; tiles are requested in the map
// projection (EPSG:3794).
export function getDigitalOrtoPhoto() {
    return new TileLayer({
        opacity: 1,
        title: 'Digital ortho photo',
        visible: true,
        showInSwitcher: true,
        source: new TileArcGISRest({
            url: orthoUrl,
            params: { FORMAT: 'jpgpng' }
        })
    });
}

export function getTopoMap() {
    return new TileLayer({
        title: 'Topo map',
        showInSwitcher: true,
        visible: false,
        source: new TileArcGISRest({
            url: topoUrl,
            params: { FORMAT: 'png' }
        })
    });
}

export function getBaseLayers() {
    return [
        getDigitalOrtoPhoto(),
        getTopoMap()
    ];
}
